import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AthleteStatus, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteAthleteStatus(): UseMutationResult<
  AxiosResponse<AthleteStatus>,
  AxiosError<ErrorMessage>,
  { athleteStatusId: string; replaceWithPrevious: boolean }
> {
  const queryClient = useQueryClient();

  const deleteAthleteStatus = (req: {
    athleteStatusId: string;
    replaceWithPrevious: boolean;
  }): Promise<AxiosResponse<AthleteStatus>> => {
    return client.delete(
      `athlete-statuses/${req.athleteStatusId}/?replace_with_previous=${req.replaceWithPrevious}`,
    );
  };

  return useMutation(deleteAthleteStatus, {
    onSuccess: response => {
      queryClient.removeQueries({
        queryKey: ['athleteStatuses'],
      });
      queryClient.invalidateQueries({
        queryKey: ['athletes', response.data.athlete],
      });
    },
  });
}
